import { createReducer, on } from '@ngrx/store';

import { CorporateReportStatusPerCorporate } from '../constants';
import { CorporateReportsStatusActions } from '../actions';

export const initialState: CorporateReportStatusPerCorporate = Object.seal({});

export const reportStatusReducer = createReducer(
  initialState,
  on(CorporateReportsStatusActions.setStatus, (state, { corporateId, dateRange, status }) => {
    return {
      ...state,
      [corporateId]: {
        ...state[corporateId],
        [dateRange]: status,
      },
    };
  })
);
